import { api } from '../services/api';
export const getTwitterSpaceInfo = async (id) => {
    return api.get(`/external/twitter/space/${id}`);
};
export const getTwitterAccount = async (username) => api.get(`/external/twitter/user/${username}`);
export const getTweet = async (id) => api.get(`/external/twitter/tweet/${id}`);
